<template>
  <div>
    <b-container fluid>
      <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
        <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
        Back
      </b-button>
      <b-row>
        <b-col class="">
          <b-skeleton-wrapper class="text-center" :loading="loading">
            <template #loading>
              <b-skeleton height="100px" width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>

          <b-skeleton-wrapper class="text-center mt-3" :loading="loading">
            <template #loading>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="90%"></b-skeleton>
              <b-skeleton width="100%" class="mt-3"></b-skeleton>
              <b-skeleton width="80%"></b-skeleton>
              <b-skeleton width="100%"></b-skeleton>
            </template>
          </b-skeleton-wrapper>

          <div v-if="userstock.length > 0 && !loading">
            <h2 class="text-center">{{ userstock[0].name }}</h2>
            <h4 class="text-center" v-if="userstock.length > 0">
              This Table has {{ userstock[0].data.length }} rows
            </h4>
            <!-- <h6 class="text-center" v-if="userstock.length > 0">
              Click on the blue Highlighted column to edit and view associated
              questions
            </h6> -->
            <tabler2
              v-if="userstock.length > 0"
              module="thirdparty"
              class="esq m-0 p-0"
              :clearance="Number(clearance)"
              :datas="userstock[0].data"
              :fields="userstock[0].fields"
            ></tabler2>
          </div>
          <paginater
            v-if="userstock.length > 0 && !loading"
            :intervalnum="intervalnum"
            :pages="pages"
            :endss="endss"
            :endnum="endnum"
            :datalength="endss"
            @paginator="newPage"
            @changeInterval="effectInterval"
          ></paginater>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import QuestionsList from "@/components/admin/QuestionsList.vue";
import Tabler2 from "@/components/admin/Tabler2";
import { mapState, mapActions } from "vuex";
import Paginater from "@/components/Paginater";

export default {
  components: {
    //QuestionsList,
    Tabler2,
    Paginater
  },

  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      loading: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.setnextid(to.params.trackid).then(() => {
      next();
    });
  },
  async mounted() {
    await this.fetchData();

    this.setCurrentModule("Test Questions");
    this.queryStocks(this.trackid);
  },
  methods: {
    ...mapActions("admin", [
      "fetchQuestions",
      "setnextid",
      "queryStocks",
      "setCurrentModule"
    ]),
    async fetchData() {
      this.loading = true;
      try {
        await this.fetchQuestions();
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    }
  },
  computed: {
    ...mapState({
      name: state => state.loginmaster.details.fullname,
      clearance: state => state.loginmaster.details.clearance_level,
      trackid: state => state.loginmaster.details.trackid,
      questionsarr: state => state.admin.listquestions,
      userstock: state => state.admin.userstockstat
    }),
    endss() {
      let end = this.userstock[0].data.length;
      return end;
    },
    usedatas() {
      return this.userstock[0].data.slice(this.startnum, this.endnum);
    },
    ranger() {
      let ranger = Math.ceil(
        this.userstock[0].data.data.length / this.intervalnum
      );
      return ranger;
    }
  }
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
</style>
